const isProduction = typeof window !== 'undefined' && window.location.hostname !== 'localhost'
const API_BASE_URL = isProduction ? 'https://api.futurabroker.com/api/v2' : 'http://localhost:4000/api/v2'

interface User {
  id: number
  name: string
  email: string
  nickname: string | null
  avatar: string | null
}

interface ValidateResponse {
  token: string
  user: User
}

export const authService = {
  /**
   * Verifica se e-mail está na whitelist (sem criar sessão)
   */
  async verifyEmail(email: string): Promise<{ authorized: boolean }> {
    const response = await fetch(`${API_BASE_URL}/admin/auth/integration-code/verify-email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: email.toLowerCase().trim(), app: 'sigma' }),
    })

    const data = await response.json()

    if (!data.success) {
      throw new Error(data.error?.message || 'E-mail não autorizado')
    }

    return data.data
  },

  /**
   * Login via e-mail autorizado (sem senha)
   */
  async loginWithEmail(email: string): Promise<ValidateResponse> {
    const response = await fetch(`${API_BASE_URL}/admin/auth/integration-code/email-login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ email: email.toLowerCase().trim(), app: 'sigma' }),
    })

    const data = await response.json()

    if (!data.success) {
      throw new Error(data.error?.message || 'E-mail não autorizado')
    }

    // Salvar token e usuário
    localStorage.setItem('sigma_token', data.data.token)
    localStorage.setItem('sigma_user', JSON.stringify(data.data.user))

    return data.data
  },

  /**
   * Valida código de integração e obtém token
   */
  async validateCode(code: string): Promise<ValidateResponse> {
    const response = await fetch(`${API_BASE_URL}/admin/auth/integration-code/validate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ code: code.replace(/\s/g, '') }), // Remove espaços
    })

    const data = await response.json()

    if (!data.success) {
      throw new Error(data.error?.message || 'Código inválido')
    }

    // Salvar token e usuário
    localStorage.setItem('sigma_token', data.data.token)
    localStorage.setItem('sigma_user', JSON.stringify(data.data.user))

    return data.data
  },

  /**
   * Faz logout (remove token e dados)
   */
  logout() {
    localStorage.removeItem('sigma_token')
    localStorage.removeItem('sigma_user')
    window.location.href = '/login'
  },

  /**
   * Verifica se usuário está autenticado
   */
  isAuthenticated(): boolean {
    const token = localStorage.getItem('sigma_token')
    return !!token
  },

  /**
   * Retorna usuário salvo no localStorage
   */
  getUser(): User | null {
    const userStr = localStorage.getItem('sigma_user')
    if (!userStr) return null
    try {
      return JSON.parse(userStr)
    } catch {
      return null
    }
  },

  /**
   * Retorna token salvo
   */
  getToken(): string | null {
    return localStorage.getItem('sigma_token')
  },
}
